package horcrux.common.types

import horcrux.common.ValidatedValueClass
import horcrux.common.api.dtos.types.ParameterName
import kotlin.jvm.JvmInline

@JvmInline
value class EndpointVersion(override val value: Int) : ValidatedValueClass<Int, EndpointVersion> {
    companion object {
        val PARAMETER_NAME: ParameterName = ParameterName("EndpointVersion")
        val ZERO: EndpointVersion = EndpointVersion(0)
        val ONE: EndpointVersion = EndpointVersion(1)
        val DEFAULT_ENDPOINT_VERSION: EndpointVersion = ZERO
    }
}
